// extracted by mini-css-extract-plugin
export var bounce = "_nl-1";
export var generatingText = "_nl-6";
export var lightning = "_nl-4";
export var popup = "_nl-5";
export var progressBar = "_nl-7";
export var progressFill = "_nl-8";
export var progressShimmer = "_nl-9";
export var progressText = "_nl-a";
export var shimmer = "_nl-3";
export var uploadIcon = "_nl-0";
export var uploadingText = "_nl-2";